<template>
  <path
    id="ic_mic_off_24px"
    d="M16.474,9.579H15.042a4.307,4.307,0,0,1-.362,1.726l1.036,1.036a5.545,5.545,0,0,0,.758-2.762Zm-3.385.143c0-.051.017-.093.017-.143V4.526a2.526,2.526,0,0,0-5.053,0v.152ZM4.069,2.842,3,3.912,8.061,8.973v.606a2.516,2.516,0,0,0,2.518,2.526,2.376,2.376,0,0,0,.547-.067l1.4,1.4a4.63,4.63,0,0,1-1.945.438A4.369,4.369,0,0,1,6.116,9.579H4.684a5.881,5.881,0,0,0,5.053,5.659V18h1.684V15.238a5.906,5.906,0,0,0,2.139-.758L17.088,18l1.069-1.069Z"
    transform="translate(-3 -2)" />
</template>
